import { GET_VERIFIED_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export const getVerifiedModal = {
	[GET_VERIFIED_MODAL_MODULE_ID]: {
		moduleType: 'modal',
	},
}
